import type { TranslationKey } from "../../i18n/translationKeys";
import type { RewardType, TileType } from "../../types";

export const REWARD_TILE: Record<RewardType, TileType> = {
  dailyRakeback: "rakeback",
  instantRakeback: "rakeback",
  cashback: "cashback",
  monthlyBonus: "monthlyBonus",
  tierUp: "tierUp",
  levelUp: "levelUp",
};

export const REWARD_LABEL: Record<RewardType, TranslationKey> = {
  dailyRakeback: "reward_center.reward.daily_rakeback",
  instantRakeback: "reward_center.reward.instant_rakeback",
  cashback: "reward_center.reward.cashback",
  monthlyBonus: "reward_center.reward.monthly_bonus",
  tierUp: "reward_center.reward.tier_up",
  levelUp: "reward_center.reward.level_up",
};
